import { combineReducers } from "redux";
import fgModules from "./fgModuleReducer";
import identity from "./identityReducer";
import { users } from "./usersReducer";

const appReducer = combineReducers({
    users,
    identity,
    fgModules,
});

const rootReducer = (state, action) => {
    if (action.type === "APP_RESET") {
        state = undefined;
        window.location.reload(); // TODO: rerender App
    }

    return appReducer(state, action);
};

export default rootReducer;
